<section>
	<custom-input [label]="'communication-log.comment-label' | translate"
				  [(value)]="newComment"
				  [required]="true"
				  [inputType]="inputType.Textarea"></custom-input>
	<add-multiple [label]="'communication-log.add-users-to-notify' | translate"
				  [placeholder]="'communication-log.add-user-name-to-notify' | translate"
				  (selectedItemsChange)="selectedItemsChange($event)"
				  [availableItems]="userItems"></add-multiple>
</section>
<section>
	<button ghost (click)="onCancel.emit()" [ignoreValidation]="true">{{ 'general.cancel' | translate }}</button>
	<button confirm (click)="saveComment()">{{ 'communication-log.add-comment' | translate }}</button>
</section>
